import { gql } from 'graphql-request';

export const GetParkTrails = gql`
  query GetParkTrails($park_id:ID!,$max_distance_meters:Int,$difficulties:[String!]) {
    parkTrails(parkId:$park_id, maxDistanceMeters:$max_distance_meters, difficulties:$difficulties) {
      allPossibleActivityTags
      allPossibleFeatureTags
      id
      name
      trailDistance
      durationString
      shortAddress
      averageRating
      numberOfRatings
      countryId
      createdAt
      updatedAt
      slug
      totalElevation
      totalElevationLoss
      elavationPerKm
      maxElevation
      lonlat
      difficulty
      publishedAt
      keywords
      staticMapImage
      numberOfDays

      stagesCount
      jumboImage {
        url
        metadata
      }
      stagesCount
      searchBoost
      impressionsCount
      durationMinutes
      tagList
      staticMapImage
      linkedBlogCount
      countrySlug
      regionSlug
      photos {
        url
        metadata
      }
    }
  }
`;
